import { TOP_BRAND } from "../../actions/type";

export default function topBrand(state = {}, action) {
    switch (action.type) {
        case TOP_BRAND:
            return action.payload;
        default:
            return state
    }
}
